export const salesAssistantContactPreferencesDe = {
  title: 'Kontaktpräferenzen und Sperren',
  description:
    'Pflege erlaubte Kontaktwege, bevorzugte Zeiten und dokumentierte Kontakt- oder Werbesperren für den Kunden oder einzelne Ansprechpartner.',
  loadError: 'Die Kontaktpräferenzen konnten nicht geladen werden.',
  scope: 'Gültig für',
  wholeCustomer: 'Gesamter Kunde',
  contactAllowed: 'Kontakt erlaubt',
  contactBlocked: 'Kontakt gesperrt',
  marketingAllowed: 'Vertriebskontakt erlaubt',
  marketingBlocked: 'Vertriebskontakt gesperrt',
  notCurrentlyEffective: 'Außerhalb des Gültigkeitszeitraums',
  permissions: 'Kontaktwege',
  channels: {
    PHONE: 'Telefon',
    EMAIL: 'E-Mail',
    VISIT: 'Besuch',
    POSTAL: 'Post',
    WHATSAPP: 'WhatsApp',
  },
  allowed: 'Erlaubt',
  blocked: 'Gesperrt',
  generalBlock: 'Allgemeine Kontaktsperre',
  generalBlockHelp: 'Verhindert jeden ausgehenden Kontakt über dieses Modul.',
  marketingBlock: 'Werbe- und Vertriebskontakte sperren',
  marketingBlockHelp: 'Servicekontakte bleiben möglich; Verkaufsansprache wird verhindert.',
  preferredChannel: 'Bevorzugter Kontaktweg',
  preferredTime: 'Bevorzugte Kontaktzeit',
  timeStart: 'Von',
  timeEnd: 'Bis',
  preferredWeekdays: 'Bevorzugte Wochentage',
  weekdays: { 1: 'Mo', 2: 'Di', 3: 'Mi', 4: 'Do', 5: 'Fr', 6: 'Sa', 7: 'So' },
  sources: {
    MANUAL: 'Intern erfasst',
    CUSTOMER_REQUEST: 'Kundenwunsch',
    IMPORT: 'Import',
    LEGAL: 'Rechtliche Vorgabe',
  },
  validFrom: 'Gültig ab',
  validUntil: 'Gültig bis',
  source: 'Quelle',
  capturedAt: 'Erfasst am',
  blockReason: 'Grund der Sperre oder Einschränkung',
  internalNote: 'Interne Anmerkung',
  deleted: 'Kontaktpräferenz entfernt.',
  saved: 'Kontaktpräferenz gespeichert.',
  manage: 'Kontaktpräferenzen',
  salesContactBlocked: 'Die Kontaktpräferenz verhindert derzeit einen Vertriebsanruf.',
} as const;

export const salesAssistantContactPreferencesEn = {
  title: 'Contact preferences and restrictions',
  description:
    'Manage allowed channels, preferred times, and documented contact or marketing restrictions for the customer or individual contacts.',
  loadError: 'Contact preferences could not be loaded.',
  scope: 'Applies to',
  wholeCustomer: 'Entire customer',
  contactAllowed: 'Contact allowed',
  contactBlocked: 'Contact blocked',
  marketingAllowed: 'Sales contact allowed',
  marketingBlocked: 'Sales contact blocked',
  notCurrentlyEffective: 'Outside validity period',
  permissions: 'Contact channels',
  channels: {
    PHONE: 'Phone',
    EMAIL: 'Email',
    VISIT: 'Visit',
    POSTAL: 'Post',
    WHATSAPP: 'WhatsApp',
  },
  allowed: 'Allowed',
  blocked: 'Blocked',
  generalBlock: 'General contact block',
  generalBlockHelp: 'Prevents every outbound contact from this module.',
  marketingBlock: 'Block marketing and sales contact',
  marketingBlockHelp: 'Service contact remains possible; sales outreach is prevented.',
  preferredChannel: 'Preferred contact channel',
  preferredTime: 'Preferred contact time',
  timeStart: 'From',
  timeEnd: 'To',
  preferredWeekdays: 'Preferred weekdays',
  weekdays: { 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat', 7: 'Sun' },
  sources: {
    MANUAL: 'Recorded internally',
    CUSTOMER_REQUEST: 'Customer request',
    IMPORT: 'Import',
    LEGAL: 'Legal requirement',
  },
  validFrom: 'Valid from',
  validUntil: 'Valid until',
  source: 'Source',
  capturedAt: 'Captured at',
  blockReason: 'Reason for restriction',
  internalNote: 'Internal note',
  deleted: 'Contact preference removed.',
  saved: 'Contact preference saved.',
  manage: 'Contact preferences',
  salesContactBlocked: 'The contact preference currently prevents a sales call.',
} as const;

export const salesAssistantContactPreferencesTr = {
  title: 'İletişim tercihleri ve kısıtlamalar',
  description:
    'Müşteri veya kişiler için izin verilen kanalları, tercih edilen saatleri ve belgelenmiş iletişim ya da pazarlama kısıtlamalarını yönetin.',
  loadError: 'İletişim tercihleri yüklenemedi.',
  scope: 'Geçerlilik alanı',
  wholeCustomer: 'Tüm müşteri',
  contactAllowed: 'İletişime izin var',
  contactBlocked: 'İletişim engelli',
  marketingAllowed: 'Satış iletişimine izin var',
  marketingBlocked: 'Satış iletişimi engelli',
  notCurrentlyEffective: 'Geçerlilik dönemi dışında',
  permissions: 'İletişim kanalları',
  channels: {
    PHONE: 'Telefon',
    EMAIL: 'E-posta',
    VISIT: 'Ziyaret',
    POSTAL: 'Posta',
    WHATSAPP: 'WhatsApp',
  },
  allowed: 'İzinli',
  blocked: 'Engelli',
  generalBlock: 'Genel iletişim engeli',
  generalBlockHelp: 'Bu modülden tüm giden iletişimi engeller.',
  marketingBlock: 'Pazarlama ve satış iletişimini engelle',
  marketingBlockHelp: 'Hizmet iletişimi mümkün kalır; satış yaklaşımı engellenir.',
  preferredChannel: 'Tercih edilen kanal',
  preferredTime: 'Tercih edilen saat',
  timeStart: 'Başlangıç',
  timeEnd: 'Bitiş',
  preferredWeekdays: 'Tercih edilen günler',
  weekdays: { 1: 'Pzt', 2: 'Sal', 3: 'Çar', 4: 'Per', 5: 'Cum', 6: 'Cmt', 7: 'Paz' },
  sources: {
    MANUAL: 'İç kayıt',
    CUSTOMER_REQUEST: 'Müşteri talebi',
    IMPORT: 'İçe aktarma',
    LEGAL: 'Yasal gereklilik',
  },
  validFrom: 'Başlangıç',
  validUntil: 'Bitiş',
  source: 'Kaynak',
  capturedAt: 'Kayıt zamanı',
  blockReason: 'Kısıtlama nedeni',
  internalNote: 'İç not',
  deleted: 'İletişim tercihi kaldırıldı.',
  saved: 'İletişim tercihi kaydedildi.',
  manage: 'İletişim tercihleri',
  salesContactBlocked: 'İletişim tercihi şu anda satış aramasını engelliyor.',
} as const;

export const salesAssistantContactPreferencesFr = {
  title: 'Préférences et restrictions de contact',
  description:
    'Gérez les canaux autorisés, les horaires préférés et les restrictions documentées pour le client ou ses contacts.',
  loadError: 'Les préférences de contact n’ont pas pu être chargées.',
  scope: 'S’applique à',
  wholeCustomer: 'Client entier',
  contactAllowed: 'Contact autorisé',
  contactBlocked: 'Contact interdit',
  marketingAllowed: 'Contact commercial autorisé',
  marketingBlocked: 'Contact commercial interdit',
  notCurrentlyEffective: 'Hors période de validité',
  permissions: 'Canaux de contact',
  channels: {
    PHONE: 'Téléphone',
    EMAIL: 'E-mail',
    VISIT: 'Visite',
    POSTAL: 'Courrier',
    WHATSAPP: 'WhatsApp',
  },
  allowed: 'Autorisé',
  blocked: 'Interdit',
  generalBlock: 'Interdiction générale de contact',
  generalBlockHelp: 'Empêche tout contact sortant depuis ce module.',
  marketingBlock: 'Interdire les contacts marketing et commerciaux',
  marketingBlockHelp: 'Le service reste possible, mais la prospection est interdite.',
  preferredChannel: 'Canal préféré',
  preferredTime: 'Horaire préféré',
  timeStart: 'De',
  timeEnd: 'À',
  preferredWeekdays: 'Jours préférés',
  weekdays: { 1: 'Lun', 2: 'Mar', 3: 'Mer', 4: 'Jeu', 5: 'Ven', 6: 'Sam', 7: 'Dim' },
  sources: {
    MANUAL: 'Saisie interne',
    CUSTOMER_REQUEST: 'Demande du client',
    IMPORT: 'Import',
    LEGAL: 'Exigence légale',
  },
  validFrom: 'Valide à partir du',
  validUntil: 'Valide jusqu’au',
  source: 'Source',
  capturedAt: 'Saisi le',
  blockReason: 'Motif de la restriction',
  internalNote: 'Note interne',
  deleted: 'Préférence de contact supprimée.',
  saved: 'Préférence de contact enregistrée.',
  manage: 'Préférences de contact',
  salesContactBlocked: 'La préférence de contact empêche actuellement un appel commercial.',
} as const;

export const salesAssistantContactPreferencesEs = {
  title: 'Preferencias y restricciones de contacto',
  description:
    'Gestiona canales permitidos, horarios preferidos y restricciones documentadas para el cliente o sus contactos.',
  loadError: 'No se pudieron cargar las preferencias de contacto.',
  scope: 'Se aplica a',
  wholeCustomer: 'Cliente completo',
  contactAllowed: 'Contacto permitido',
  contactBlocked: 'Contacto bloqueado',
  marketingAllowed: 'Contacto comercial permitido',
  marketingBlocked: 'Contacto comercial bloqueado',
  notCurrentlyEffective: 'Fuera del periodo de validez',
  permissions: 'Canales de contacto',
  channels: {
    PHONE: 'Teléfono',
    EMAIL: 'Correo',
    VISIT: 'Visita',
    POSTAL: 'Correo postal',
    WHATSAPP: 'WhatsApp',
  },
  allowed: 'Permitido',
  blocked: 'Bloqueado',
  generalBlock: 'Bloqueo general de contacto',
  generalBlockHelp: 'Impide todo contacto saliente desde este módulo.',
  marketingBlock: 'Bloquear marketing y ventas',
  marketingBlockHelp: 'El servicio sigue disponible; se impide la comunicación comercial.',
  preferredChannel: 'Canal preferido',
  preferredTime: 'Horario preferido',
  timeStart: 'Desde',
  timeEnd: 'Hasta',
  preferredWeekdays: 'Días preferidos',
  weekdays: { 1: 'Lun', 2: 'Mar', 3: 'Mié', 4: 'Jue', 5: 'Vie', 6: 'Sáb', 7: 'Dom' },
  sources: {
    MANUAL: 'Registro interno',
    CUSTOMER_REQUEST: 'Solicitud del cliente',
    IMPORT: 'Importación',
    LEGAL: 'Requisito legal',
  },
  validFrom: 'Válido desde',
  validUntil: 'Válido hasta',
  source: 'Fuente',
  capturedAt: 'Registrado el',
  blockReason: 'Motivo de la restricción',
  internalNote: 'Nota interna',
  deleted: 'Preferencia de contacto eliminada.',
  saved: 'Preferencia de contacto guardada.',
  manage: 'Preferencias de contacto',
  salesContactBlocked: 'La preferencia de contacto impide actualmente una llamada comercial.',
} as const;

export const salesAssistantContactPreferencesRu = {
  title: 'Предпочтения и ограничения связи',
  description:
    'Настройте разрешённые каналы, предпочтительное время и документированные ограничения для клиента или контактных лиц.',
  loadError: 'Не удалось загрузить предпочтения связи.',
  scope: 'Применяется к',
  wholeCustomer: 'Весь клиент',
  contactAllowed: 'Связь разрешена',
  contactBlocked: 'Связь запрещена',
  marketingAllowed: 'Коммерческая связь разрешена',
  marketingBlocked: 'Коммерческая связь запрещена',
  notCurrentlyEffective: 'Вне срока действия',
  permissions: 'Каналы связи',
  channels: {
    PHONE: 'Телефон',
    EMAIL: 'Эл. почта',
    VISIT: 'Визит',
    POSTAL: 'Почта',
    WHATSAPP: 'WhatsApp',
  },
  allowed: 'Разрешён',
  blocked: 'Запрещён',
  generalBlock: 'Полный запрет связи',
  generalBlockHelp: 'Запрещает все исходящие контакты из этого модуля.',
  marketingBlock: 'Запретить маркетинговые и коммерческие контакты',
  marketingBlockHelp: 'Сервисная связь остаётся доступной, продажи запрещены.',
  preferredChannel: 'Предпочтительный канал',
  preferredTime: 'Предпочтительное время',
  timeStart: 'С',
  timeEnd: 'До',
  preferredWeekdays: 'Предпочтительные дни',
  weekdays: { 1: 'Пн', 2: 'Вт', 3: 'Ср', 4: 'Чт', 5: 'Пт', 6: 'Сб', 7: 'Вс' },
  sources: {
    MANUAL: 'Внутренняя запись',
    CUSTOMER_REQUEST: 'Запрос клиента',
    IMPORT: 'Импорт',
    LEGAL: 'Требование закона',
  },
  validFrom: 'Действует с',
  validUntil: 'Действует до',
  source: 'Источник',
  capturedAt: 'Зафиксировано',
  blockReason: 'Причина ограничения',
  internalNote: 'Внутренняя заметка',
  deleted: 'Предпочтение связи удалено.',
  saved: 'Предпочтение связи сохранено.',
  manage: 'Предпочтения связи',
  salesContactBlocked: 'Предпочтение связи сейчас запрещает коммерческий звонок.',
} as const;
